<template>
 <div>
   <p v-if="isTitle" class="title">Job Type</p>
   <div class="container">
     <job-tag v-for="tag in options" :key="tag.id + tag.rewardPercentage" :active="isActive(tag)" @addTag="addTag" @removeTag="removeTag" :name="tag.name" :value="tag"></job-tag>
   </div>
 </div>
</template>

<script>
import JobTag from '../general/job-tag.vue'
import Columns from '../general/columns.vue'
import Column from '../general/column.vue'
export default {
  name: 'JobTypeTags',
  components: {
    JobTag,
    Columns,
    Column
  },
  props: {
    options: {
      type: Array
    },
    isTitle: {
      type: Boolean,
      default: true
    },
    value: {
      type: String
    },
    onChangeTag: {
      type: Function
    }
  },
  methods: {
    addTag (value) {
      this.$emit('onChangeTag', value.id)
    },
    removeTag (value) {
      this.$emit('onChangeTag', '')
    },
    isActive (value) {
      if (value.id === this.value) { return true }
      return false
    }
  }
}
</script>

<style scoped>
.title{
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;

  color: #000000;
  margin-bottom: 10px;
}
.mb-10{
  margin-bottom: 10px;
}

.container {
  display: flex;
  flex-flow: wrap;
  gap: 10px;
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/job-type-tags.vue